import { AfterViewInit, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SortDescriptor, State } from '@progress/kendo-data-query';
import { IColumns, ICardSorter } from 'bi-interfaces';
import { BIModulesService } from '../../bi-modules.service';
import { MessageService } from '@progress/kendo-angular-l10n';

@Component({
  selector: 'bi-card-sorter',
  templateUrl: './bi-card-sorter.component.html',
  styleUrls: ['./bi-card-sorter.component.scss']
})
export class BiCardSorterComponent implements ICardSorter, AfterViewInit {

  state !: State;
  SortingOrder: "asc" | "desc" | undefined = 'asc';
  data !: {
    value: SortDescriptor[],
    Columns: IColumns[],
    Dialog: any
  };

  constructor(public translateService: TranslateService, public myBiser:BIModulesService,public mymess:MessageService){
    this.mymess.notify(this.myBiser.getDir())
  }

  ngOnInit(): void {
    if (!this.data.value) {
      this.data.value = [{ field: this.data.Columns[0].Name, dir: this.SortingOrder }]
    }
    this.SortingOrder = this.data.value[0].dir;
  }

  ngAfterViewInit(): void {
  }

  editorValueChange(ColumnName: any): void {
    this.data.value = [{ field: ColumnName, dir: this.SortingOrder }]
  }

  OnOk() {
    if (this.data.value) {
      this.data.value[0].dir = this.SortingOrder;
      this.state = { sort: this.data.value }
    }
    this.data.Dialog.DialogReturnSubject.next({
      state: this.state
    });
  }

  OnCancel() { }

}
